import React, { useEffect , useState} from "react";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useTranslation } from 'react-i18next';
import ListNewRenameForm from '../forms/ListNewRenameForm'

function ListFormModal(props) {

  useEffect(() => {
      setShow(props.show);
  }, [props.show]);

  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const handleFormSubmit = (reloadData) => {
    props.handleModalClose(reloadData)
  }

  return (

      <Modal
        animation={true}
        show={show }
        onHide={() => props.handleModalClose(false) }
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>{props.list_id ? t('Rename List') : t('Create New List') }</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListNewRenameForm list_id={props.list_id} onSuccessfulFormSubmit={handleFormSubmit}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => props.handleModalClose(false)}>
            {t('Close')}
          </Button>
        </Modal.Footer>
      </Modal>

  );
}

export default ListFormModal
